import { motion } from "framer-motion";

// Semicircular gauge showing how long money lasts vs planned horizon.
export const LongevityGauge = ({ result }) => {
  const ratio = Math.max(0, Math.min(1, result.yearsLasted / result.retirementYears));
  const angle = ratio * 180;

  const color =
    result.status === "surplus" ? "#2D6A4F" : result.status === "warning" ? "#B45309" : "#991B1B";

  const cx = 110, cy = 110, r = 90;
  const polar = (deg) => {
    const rad = (Math.PI * (180 - deg)) / 180;
    return { x: cx + r * Math.cos(rad), y: cy - r * Math.sin(rad) };
  };
  const arc = (startDeg, endDeg) => {
    const s = polar(startDeg), e = polar(endDeg);
    const large = endDeg - startDeg > 180 ? 1 : 0;
    return `M ${s.x} ${s.y} A ${r} ${r} 0 ${large} 1 ${e.x} ${e.y}`;
  };

  return (
    <div className="bg-white rounded-2xl border border-[#E8E3D9] shadow-sm p-6 flex flex-col items-center"
      data-testid="longevity-gauge">
      <h3 className="font-heading text-lg font-semibold text-[#1A231F] self-start mb-1">Corpus Longevity</h3>
      <p className="text-sm text-[#8A9790] self-start mb-3">How long your money lasts</p>

      <div className="relative">
        <svg width="220" height="128" viewBox="0 0 220 128">
          <path d={arc(0, 180)} fill="none" stroke="#EDE8DE" strokeWidth="16" strokeLinecap="round" />
          <motion.path
            d={arc(0, 180)}
            fill="none"
            stroke={color}
            strokeWidth="16"
            strokeLinecap="round"
            strokeDasharray={Math.PI * r}
            initial={{ strokeDashoffset: Math.PI * r }}
            animate={{ strokeDashoffset: Math.PI * r * (1 - ratio) }}
            transition={{ duration: 1, ease: "easeOut" }}
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-end pb-1">
          <div className="font-mono text-3xl font-bold" style={{ color }}>
            {result.yearsLasted}
          </div>
          <div className="text-xs text-[#8A9790]">of {result.retirementYears} yrs</div>
        </div>
      </div>

      <div className="mt-3 text-center text-sm text-[#5C6A64]">
        {result.depletionAge !== null
          ? `Funds deplete at age ${result.depletionAge}`
          : "Funds outlast your entire plan 🎉"}
      </div>
    </div>
  );
};
